import {} from "@material-ui/core";
import {
    Backdrop as BackdropBase,
    BackdropProps,
    CircularProgress,
    Stack,
} from "@mui/material";
import eFileMadeEasyColors from "./EFMEColors";
import React from "react";

const Backdrop = (params: BackdropProps) => {
    return (
        <BackdropBase
            sx={{
                color: "#000",
                zIndex: 1000,
                backdropFilter: "blur(5px)", // Add this line
                "-webkit-backdrop-filter": "blur(5px)", // For older Chrome/Safari browsers
                "-moz-backdrop-filter": "blur(5px)", // For Firefox
            }}
            open={params.open}
            onClick={params.onClick}
        >
            <Stack direction={"column"} spacing={8}>
                <svg width={0} height={0}>
                    <defs>
                        <linearGradient
                            id="my_gradient"
                            x1="0%"
                            y1="0%"
                            x2="0%"
                            y2="100%"
                        >
                            <stop
                                offset="0%"
                                stopColor={eFileMadeEasyColors.greener}
                            />
                            <stop
                                offset="75%"
                                stopColor={eFileMadeEasyColors.blue}
                            />
                            <stop
                                offset="100%"
                                stopColor={eFileMadeEasyColors.darkBlue}
                            />
                        </linearGradient>
                    </defs>
                </svg>
                <CircularProgress
                    sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
                />
                <h2>
                    <b>{params.title}</b>
                </h2>
            </Stack>
        </BackdropBase>
    );
};

export default Backdrop;
